<template>
  <div>
    <b-card-group class="card-group mt-3 py-3" cols>
      <b-card
        v-for="card in cardComponents"
        :key="card.id"
        bg-variant="warning"
        text-variant="white"
        class="card text-center"
        cols="1" sm="5" md="4" lg="3" xl="2"
      >
        <div class="card-data">
          <b-link class="link" @click="openModalViewEmployee(card)">
            <b-card-text class="content-card text-white">
              <div class="card-icon">
                <div class="image-card">
                  <img :src="getImgUrl(card.icon)" style="width: 40px;">
                </div>
              </div>
              <div class="card-info">
                <h1><b>{{ card.summary }}</b></h1>
                <p class="mt-2"><b>{{ card.title }}</b></p>
              </div>
            </b-card-text>
          </b-link>
        </div>
      </b-card>
    </b-card-group>
    <div>
      <TableCategoryEmployee
        :employees="filteredEmployees"
        :title="title"
      />
    </div>
  </div>
</template>

<script>
import TableCategoryEmployee from '@/components/TableCategoryEmployee.vue'

export default {
  components: { TableCategoryEmployee },
  props: {
    employee: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      cardComponents: [
        { id: 1, icon: 'user.png', summary: 0, title: 'Permanent Employee' },
        { id: 2, icon: 'hourglass.png', summary: 0, title: 'Contract Employee' },
        { id: 3, icon: 'icon-probation.png', summary: 0, title: 'Probation Employee' },
        { id: 4, icon: 'remove-user.png', summary: 0, title: 'Resigned Employee' },
        { id: 5, icon: 'employees.png', summary: 0, title: 'Total Employee' }
      ],
      employeePosition: {},
      filteredEmployees: [],
      showModal: false,
      title: ''
    }
  },
  created() {
    this.employeePosition = this.employee
    this.cardComponents[0].employee = this.employeePosition.employeePermanent
    this.cardComponents[1].employee = this.employeePosition.employeeTemporary
    this.cardComponents[2].employee = this.employeePosition.employeeProbation
    this.cardComponents[3].employee = this.employeePosition.formerEmployee
  },
  watch: {
    employeePosition: {
      handler() {
        this.cardComponents[0].summary = this.employeePosition.employeePermanent.length
        this.cardComponents[1].summary = this.employeePosition.employeeTemporary.length
        this.cardComponents[2].summary = this.employeePosition.employeeProbation.length
        this.cardComponents[3].summary = this.employeePosition.formerEmployee.length
        this.cardComponents[4].summary = (this.employeePosition.employeePermanent ? this.employeePosition.employeePermanent.length : 0) +
                                        (this.employeePosition.employeeTemporary ? this.employeePosition.employeeTemporary.length : 0) +
                                        (this.employeePosition.employeeProbation ? this.employeePosition.employeeProbation.length : 0)
      },
      deep: true
    }
  },
  methods: {
    getImgUrl(imagePath) {
      return require('@/assets/' + imagePath)
    },
    openModalViewEmployee(item) {
      this.filteredEmployees = []
      if (item.id === 1) { // id 1 used for Permanent Employee
        this.filteredEmployees = this.employeePosition.employeePermanent
      } else if (item.id === 2) { // id 2 user for Contract Employee
        this.filteredEmployees = this.employeePosition.employeeTemporary
      } else if (item.id === 3) { // id 3 used for Probation Employee
        this.filteredEmployees = this.employeePosition.employeeProbation
      } else if (item.id === 4) { // id 4 used for Resigned Employee
        this.filteredEmployees = this.employeePosition.formerEmployee
      } else if (item.id === 5) { // id 5 used for Total Employee
        this.filteredEmployees = this.employeePosition.employeePermanent.concat(this.employeePosition.employeeTemporary, this.employeePosition.employeeProbation)
      }
      this.title = item.title
      this.$bvModal.show('modal-view-employee-postion')
    },
    countEmployeeInList(list) {
      if (list) {
        return list.length
      } else {
        return 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card{
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
}

.card[data-v-1c0b93b5]{
  margin-right: 20px;
  margin-left: 20px;
  border-radius: 10px;
}

.link{
  text-decoration: none;
}

.card-icon{
  display: flex;
  margin-bottom: 10px;
}

.card-icon .image-card{
  width: 65px;
  height: 65px;
  border-radius: 50%;
  background-color: white;
  display: inline-block;
}

.card-icon .image-card img{
  margin: 10px 10px 10px 10px;
}

.card-info{
  margin-bottom: 10px;
  font-size: 10px;
}

.card-info h1, p{
  margin: 0;
  h1{
    font-size: 60px;
  }
  p{
    font-size: 16px;
  }
}

.card-data{
  cursor: pointer;
}

.card:hover{
  box-shadow: 0 0 20px 0 rgba(0,0,0,0.2);
}

</style>
